export const langText: any = {
    us: {
        prefix: '',
        suffix: '',
        cart: 'Add to Cart',
    },
    jp: {
        prefix: '通常価格',
        suffix: '（税込）',
        cart: 'カートに追加',
    },
};
